import React, { ReactNode } from 'react';
import { Bell } from 'lucide-react';

interface SystemAlertProps {
    title: string;
    message: string | ReactNode;
    icon?: ReactNode;
    severity?: 'info' | 'warning' | 'error' | 'success';
}

const SystemAlert: React.FC<SystemAlertProps> = ({ 
    title, 
    message, 
    icon = <Bell className="h-5 w-5" />, 
    severity = 'info' 
}) => {
    const colorMap = {
        info: {
            bg: 'bg-blue-50',
            border: 'border-blue-400',
            titleColor: 'text-blue-800',
            textColor: 'text-blue-700',
            iconColor: 'text-blue-400'
        },
        warning: {
            bg: 'bg-amber-50',
            border: 'border-amber-400',
            titleColor: 'text-amber-800',
            textColor: 'text-amber-700',
            iconColor: 'text-amber-400'
        },
        error: {
            bg: 'bg-red-50',
            border: 'border-red-400',
            titleColor: 'text-red-800',
            textColor: 'text-red-700',
            iconColor: 'text-red-400'
        },
        success: {
            bg: 'bg-green-50',
            border: 'border-green-400',
            titleColor: 'text-green-800',
            textColor: 'text-green-700',
            iconColor: 'text-green-400'
        }
    };

    const { bg, border, titleColor, textColor, iconColor } = colorMap[severity];

    return (
        <div className={`${bg} border-l-4 ${border} p-4 rounded-md mb-6`}>
            <div className="flex">
                <div className="flex-shrink-0">
                    <div className={iconColor}>{icon}</div>
                </div>
                <div className="ml-3">
                    <h3 className={`text-sm font-medium ${titleColor}`}>{title}</h3>
                    <div className={`mt-2 text-sm ${textColor}`}>
                        {typeof message === 'string' ? <p>{message}</p> : message}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SystemAlert;